<template>
    <templateLogin>
        <div class="header">
        </div>
        <div class="body">
            <div class="box-login md">
                <form action="#" method="post">
                    <div class="title">
                        <h1>{{texts.title}}</h1>
                        <p>{{texts.text}}</p>
                    </div>
                    <div v-show="form.message" ref="message" class="message mb-15" v-html="form.message"></div>

                    <ui-input label="Nome de usuário:" ref="first_name" v-model="form.data.first_name"></ui-input>
                    
                    <grid-row>
                        <grid-col>
                            <ui-input type="email" label="E-mail:" ref="email" v-model="form.data.email"></ui-input>
                        </grid-col>
                        <grid-col>
                            <ui-input type="tel" label="Celular:" ref="mobile" v-model="form.data.mobile" mask="(##) #####-####"></ui-input>
                        </grid-col>
                    </grid-row>

                    <grid-row>
                        <grid-col v-if="fieldCPF">
                            <ui-input type="text" label="CPF" ref="cpf" v-model="form.data.cpf" v-cpf mask="###.###.###-##"></ui-input>
                        </grid-col>
                        <grid-col v-if="labelFieldIndentifier">
                            <ui-input type="text" :label="labelFieldIndentifier + ':'" ref="creci" v-model="form.data.creci"></ui-input>
                        </grid-col>
                    </grid-row>

                    <grid-row>
                        <grid-col>
                            <ui-select label="Equipe:" :options="teamsData" :load="teamsLoad" v-model="form.data.team" ref="team">
                                <option v-for="item in teamsData" :key="item.id" :value="item.id">{{item.name}}</option>
                            </ui-select>
                        </grid-col>
                        <grid-col>
                            <ui-select label="Gerente:" :options="managersData" design="mb-15" :load="managersLoad" v-model="form.data.manager_id" ref="manager_id">
                                <option v-for="item in managersData" :key="item.id" :value="item.manager_id">{{item.first_name}}</option>
                            </ui-select>
                        </grid-col>
                    </grid-row>
                    
                    <grid-row>
                        <grid-col>
                            <ui-input type="password" label="Senha:" ref="password" v-model="form.data.password" ></ui-input>
                        </grid-col>
                        <grid-col>
                            <ui-input type="password" label="Confirmar Senha:" ref="confirm_password" v-model="form.data.confirm_password"></ui-input>
                        </grid-col>
                    </grid-row>

                    <div class="control">
                        <ui-button type="button" design="lg primary block" :class="form.status" @click="doRegister">Cadastrar</ui-button>
                    </div>

                    <div class="back-link">
                        <router-link to="/"><i class="fal fa-long-arrow-left"></i> Login</router-link>
                    </div>

                </form>
            </div>
        </div>
    </templateLogin>
</template>

<script>
    import templateLogin from '@/templates/page-login'
    import { uiButton } from '@/components/ui/buttons'
    import { uiInput, uiSelect } from '@/components/ui/form'
    import { register, offline } from '@/services/axios'
    import { gridRow, gridCol }  from '@/components/ui/grid'
    import helpers from "@/mixins/helpers"
    import { cpf } from "@/directives"

    import { storage } from '@/services/storage'

    export default {
        components: { templateLogin, uiButton, uiInput, uiSelect, gridRow, gridCol },
        mixins: [ helpers ],
        directives: { cpf },
        data() {
            return {
                erros: [],
                teamsLoad: true,
                managersLoad: false,
                teamsData: [],
                managersData: [],
                fieldCPF: false,
                labelFieldIndentifier: '',
                form:{
                    message: '',
                    status: '',
                    data: {
                        first_name: '',
                        email: '',
                        mobile: '',
                        cpf: '',
                        creci: '',
                        user_group: 'broker',
                        manager_id: '',
                        password: '',
                        confirm_password: '',
                    }
                },
                texts: {
                    title: 'Criar Conta',
                    text: 'Informe os seus dados pessoais.',
                }
            }
        },
        computed: {
            team() {
                return this.form.data.team;
            }
        },
        watch: {
            team(id) {
                this.managers(id)
            }
        },
        methods: {

            doRegister(e){

                e.preventDefault();

                this.form.status    = "loading"
                this.form.message   = ""
                this.errors         = [];

                if (!this.form.data.first_name) {
                    this.errors.push('&bull; Informe o seu nome completo. <br>')
                    this.$refs.first_name.$el.classList.add('error')
                }

                if (!this.form.data.email) {
                    this.errors.push('&bull; É necessário informar um e-mail válido. <br>')
                    this.$refs.email.$el.classList.add('error')
                }

                if (!this.form.data.mobile || this.form.data.mobile.replace(/\s/g, "").length !== 14) {
                    this.errors.push('&bull; O campo celular é obrigatório. <br>')
                    this.$refs.mobile.$el.classList.add('error')
                }

                if (!this.form.data.cpf && this.fieldCPF) {
                    this.errors.push('&bull; O campo CPF é obrigatório. <br>')
                    this.$refs.cpf.$el.classList.add('error')
                    
                } else if (!this.validateCpf(this.form.data.cpf) && this.fieldCPF) {
                    this.errors.push('&bull; Informe um CPF válido. <br>')
                    this.$refs.cpf.$el.classList.add('error')
                }

                if (!this.form.data.creci && this.labelFieldIndentifier != '') {
                    this.errors.push('&bull; O campo creci é obrigatório. <br>')
                    this.$refs.creci.$el.classList.add('error')
                }

                if (!this.form.data.team || this.form.data.team === "clear") {
                    this.errors.push('&bull; É necessário selecionar uma equipe. <br>')
                    this.$refs.team.$el.classList.add('error')
                }

                if (!this.form.data.manager_id || this.form.data.manager_id === "clear") {
                    this.errors.push('&bull; É necessário selecionar um gerente. <br>')
                    this.$refs.manager_id.$el.classList.add('error')
                }

                if (!this.form.data.password) {
                    this.errors.push('&bull; É necessário informar uma senha. <br>')
                    this.$refs.password.$el.classList.add('error')
                }

                if (this.form.data.confirm_password !== this.form.data.password) {
                    this.errors.push('&bull; As senhas informada não são iguais. <br>')
                    this.$refs.password.$el.classList.add('error')
                    this.$refs.confirm_password.$el.classList.add('error')
                }


                if(this.errors.length){
                    this.form.status = false
                    this.form.message = ""
                    this.errors.map(msg => {
                        this.form.message += msg
                    })

                    return false
                }


                let sendData = {
                    first_name: this.form.data.first_name,
                    email: this.form.data.email,
                    mobile: this.form.data.mobile,
                    cpf: this.form.data.cpf,
                    creci: this.form.data.creci,
                    user_group: this.form.data.user_group,
                    manager_id: this.form.data.manager_id !== "clear" ? this.form.data.manager_id : "null",
                    password: this.form.data.password,
                }


                register.register(sendData)
                    .then(response => {
                        this.form.status = ""
                        if (response.data.status !== "error") {
                            this.$router.push({
                                name: 'message',
                                params: {
                                    title: 'Cadastro concluído!',
                                    text: 'O seu cadastro foi realizado com sucesso. O seu cadastrado poderá passar por análise. </br> Aproveite todas as vantagens de usar o Facilita.',
                                    icon: 'fal fa-comment-alt-check',
                                    type: 'success',
                                    btnUrl: '/',
                                    btnText: 'Entrar'
                                }
                            })
                            return false;
                        }

                        
                        if (typeof(response.data.msg) === "object") {
                            Object.keys(response.data.msg).forEach(key => {
                                this.$refs[key].$el.classList.add('error')
                            })
                            this.form.message = "Alguns campos não foram preenchidos corretamente."
                        } else {
                            this.form.message = response.data.msg
                        }
                        
                    })
                
            },

            teams(){
                offline.getTeams()
                    .then(response => {
                        this.teamsData = response.data
                        this.teamsLoad = false
                    })
            },

            managers(id) {
                this.managersData = []
                if (id !== "clear") {
                    this.managersLoad = true
                    offline.getManagerByTeam(id)
                        .then(response => {
                            if (response.data.status !== "error") {
                                this.managersData = response.data                        
                            }
                            this.managersLoad = false
                        })
                }
            },
            getConfigurations(){
                this.labelFieldIndentifier = storage.get('field_identifier');
                this.fieldCPF = JSON.parse(storage.get('field_cpf'));
            }
        },
        created(){
            this.teams()
            this.getConfigurations()
        }
    };
</script>
